import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { SharedInstance } from "../types/SharedInstance";
import { Container, Card, Spinner, Alert, Row, Col } from "react-bootstrap";

const SharedInstancePage = () => {
    const { id } = useParams<{ id: string }>();
    const apiURL = process.env.REACT_APP_WebAPIRootURL;

    const [data, setData] = useState<SharedInstance | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!id) return;

        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await fetch(
                    `${apiURL}/shared-instances/${id}`/* ,
                    {
                        headers:{
                            accept: 'application/json', 'User-agent':'witnessed-web'
                        }
                    } */
                );

                if (!response.ok) {
                    throw new Error("Failed to fetch data.");
                }

                const result: SharedInstance = await response.json();
                setData(result);
            }
            catch (err: any) {
                setError(err.message);
            }
            finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [id, apiURL]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!data) return <div>No data found</div>;

  return (
    <Container className="mt-5">
      {loading && (
        <div className="text-center">
          <Spinner animation="border" />
        </div>
      )}

      {error && <Alert variant="danger">{error}</Alert>}

      {data && (
        <Card>
            <Row>
                <Col md={4}>
                    <img
                        src={data.originalBlobURL}
                        alt="Verified"
                        className="img-fluid rounded-start"
                        style={{ height: "100%", objectFit: "cover" }}
                    />
                </Col>
                <Col>
                    <Card.Body>
                        <Card.Title className="mb-4">Verified Photo & Metadata</Card.Title>
                        <Row className="mb-3">
                        <Col sm={3}>
                            <strong>Name of User:</strong>
                        </Col>
                        <Col sm={9}>
                            {data.nameOfUser}
                        </Col>
                        </Row>
                        <Row className="mb-3">
                        <Col sm={3}>
                            <strong>Time Info:</strong>
                        </Col>
                        <Col sm={9}>
                            {data.timeInfo}
                        </Col>
                        </Row>
                        <Row className="mb-3">
                        <Col sm={3}>
                            <strong>Location Info:</strong>
                        </Col>
                        <Col sm={9}>
                            {data.locationInfo}
                        </Col>
                        </Row>
                        <Row className="mb-3">
                        <Col sm={3}>
                            <strong>Device Info:</strong>
                        </Col>
                        <Col sm={9}>
                            {data.deviceInfo}
                        </Col>
                        </Row>            
                    </Card.Body>
                </Col>
            </Row>
        </Card>
      )}
    </Container>
  );

};

export default SharedInstancePage;